module.exports = __webpack_public_path__ + "img/Eat.e7520b81.png";